import script from "./OldFormRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./OldFormRenderer.vue?vue&type=script&setup=true&lang=js"

import "./OldFormRenderer.vue?vue&type=style&index=0&id=f9eba210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9eba210"]])

export default __exports__